import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetBenchmarkRetailMonthValuesMutationVariables = Types.Exact<{
  input: Types.SetBenchmarkRetailMonthValuesInput;
}>;


export type SetBenchmarkRetailMonthValuesMutation = { __typename?: 'Mutation', setBenchmarkRetailMonthValues: { __typename?: 'BenchmarkRetailMonthPayload', month?: { __typename?: 'BenchmarkRetailMonth', communityId: string, reportingUnitId: string, periodId: string, status?: Types.BenchmarkSubmissionStatus | null, version?: number | null, submissionId?: string | null, values?: { __typename?: 'BenchmarkRetailMonthValues', grossSales: number, customerCount: number, grossMarginDollars: number, laborDollars: number, laborHours: number, unitCount?: number | null } | null } | null, warnings: Array<{ __typename?: 'BenchmarkRetailMonthFinding', field: string, code: string, message: string }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordKind: Types.RecordKind, recordId?: string | null }> | null } };


export const SetBenchmarkRetailMonthValuesDocument = new TypedDocumentString(`
    mutation SetBenchmarkRetailMonthValues($input: SetBenchmarkRetailMonthValuesInput!) {
  setBenchmarkRetailMonthValues(input: $input) {
    month {
      ...BenchmarkRetailMonthFields
    }
    warnings {
      field
      code
      message
    }
    errors {
      code
      message
      recordKind
      recordId
    }
  }
}
    fragment BenchmarkRetailMonthFields on BenchmarkRetailMonth {
  communityId
  reportingUnitId
  periodId
  status
  version
  submissionId
  values {
    ...BenchmarkRetailMonthValuesFields
  }
}
fragment BenchmarkRetailMonthValuesFields on BenchmarkRetailMonthValues {
  grossSales
  customerCount
  grossMarginDollars
  laborDollars
  laborHours
  unitCount
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetBenchmarkRetailMonthValues: build.mutation<SetBenchmarkRetailMonthValuesMutation, SetBenchmarkRetailMonthValuesMutationVariables>({
      query: (variables) => ({ document: SetBenchmarkRetailMonthValuesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetBenchmarkRetailMonthValuesMutation } = injectedRtkApi;
